import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { useGetVendorPaymentTerm } from "../../hooks/useGetVendorPaymentTerm"
import { formatAccountingPeriodLong } from "../../utils/accountingPeriod"
import { formatVendorType } from "../../utils/formatVendorType"

import type { Company } from "@/graphql/codegen/graphql"
import { AccountDetailsField } from "@/screens/Accounting/components/AccountDetailsField"
import { AddressFormat } from "@/types/common"
import { formatLocationAddress } from "@/utils/utils"

interface InvoiceVendorDetailsProps {
  company?: Company | null
  accountingPeriod?: string | null
}

export const InvoiceVendorDetails: FC<InvoiceVendorDetailsProps> = ({ company, accountingPeriod }) => {
  const vendorName = company?.name ?? ""
  const aerosNumber = company?.publicId ?? ""
  const as400Number = company?.externalSystemId ?? ""
  const accountType = formatVendorType(company?.types)
  const billToAddress = formatLocationAddress(company?.billingLocation, AddressFormat.BillTo)
  const { vendorPaymentTermName, isFetching: isPaymentTermFetching } = useGetVendorPaymentTerm(company?.companyId)

  return (
    <Box className='flex flex-col gap-2 p-4'>
      <Typography variant='subtitle2' className='text-gray-700'>
        Vendor Details
      </Typography>
      <Box className='flex flex-col gap-y-4'>
        <Box className='flex flex-wrap gap-x-12 gap-y-4'>
          <AccountDetailsField label='Vendor Name' value={vendorName} />
          <AccountDetailsField label='Aeros #' value={aerosNumber} />
          <AccountDetailsField label='AS400 #' value={as400Number} />
          <AccountDetailsField label='Account Type' value={accountType} />
          <AccountDetailsField label='Bill To Address' value={billToAddress} />
        </Box>
        <Box className='flex flex-wrap gap-x-12 gap-y-4'>
          <AccountDetailsField
            label='Payment Terms'
            value={isPaymentTermFetching ? "" : (vendorPaymentTermName ?? "-")}
          />
          <AccountDetailsField label='Accounting Period' value={formatAccountingPeriodLong(accountingPeriod) ?? ""} />
        </Box>
      </Box>
    </Box>
  )
}
